import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Select, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  getComplexes,
  changeSelectedComplex,
  toggleCreateComplexModal,
  changeComplexStartDate,
  changeComplexPauseStatus,
} from '../../../actions/complex';
import { setUserCurrentDay } from '../../../actions/templateGenerator';
import { setDayTabSelect } from '../../../actions/setParams';
import CreateComplexModal from './CreateComplexModal';
import { getFolders } from '../../../actions/folders';
import ChangeComplexStartDateModal from '../../Menus/ControlUsers/ChangeComplexStartDateModal';
import ChangeStatusPauseButton from '../../Menus/ControlUsers/ChangeStatusPauseButton';

const Complex = ({
  selectedComplex,
  complexes,
  loader,
  getComplexes,
  changeSelectedComplex,
  user,
  isShowCreateComplexModal,
  toggleCreateComplexModal,
  getFolders,
  isShowRecommendedTemplate,
  setDayTabSelect,
  setUserCurrentDay,
  complexTypeChange,
  changeComplexStartDate,
  changeComplexPauseStatus,
}) => {
  if (!user.id) return null;

  const [isChangeComplexStartDate, setIsChangeComplexStartDate] = useState(false);
  const [isDayOnPauseTomorrow, setIsDayOnPauseTomorrow] = React.useState(false);
  const [isPauseTakeOffTomorrow, setIsPauseTakeOffTomorrow] = React.useState(false);

  const searchReccomendedTamplate = (userID, selectedComplexPeriod) => {
    if (!isShowRecommendedTemplate) {
      getFolders();
    } else {
      let genderTag = '';
      if (user.params.gender.gender === 'Женский') {
        genderTag = [94];
      } else if (user.params.gender.gender === 'Мужской') {
        genderTag = [93];
      }
      getFolders(1, '', genderTag, userID, selectedComplexPeriod);
    }
  };

  const findCurrentСourseDay = (selectedComplexObj) => {
    const currentDate = moment().format('YYYY-MM-DD').split('-');
    const startDate = selectedComplexObj.start_date.split('-');
    const formatedCurrentDate = moment(currentDate);
    const formatedStartDate = moment(startDate);
    formatedStartDate.subtract(1, 'days'); // the current day must be 1 more
    const currentMenuDay = formatedCurrentDate.diff(formatedStartDate, 'days');
    if (+currentMenuDay <= selectedComplexObj.duraction && currentMenuDay > 0) {
      setDayTabSelect(currentMenuDay - 1);
      setUserCurrentDay(currentMenuDay);
    } else {
      setDayTabSelect(0);
      setUserCurrentDay(0);
    }
  };

  useEffect(() => {
    if (selectedComplex) {
      complexTypeChange(selectedComplex.is_individual);
    }
    if (selectedComplex && selectedComplex.start_date) {
      findCurrentСourseDay(selectedComplex);
    } else {
      setDayTabSelect(0);
      setUserCurrentDay(0);
    }
  }, [selectedComplex]);

  useEffect(() => {
    getComplexes(user.id);
  }, [user.id]);

  const onHandlePause = (complexId, data) => {
    changeComplexPauseStatus(complexId, data, user.id);
  };

  const onHandleDateChange = () => {
    setIsChangeComplexStartDate(true);
  };

  const onChangeComplexStartDate = (data) => {
    changeComplexStartDate(selectedComplex.id, data, user.id);
    setIsChangeComplexStartDate(false);
  };

  const onChangeComplex = (selectedComplexValueFromSelect) => {
    if (!selectedComplexValueFromSelect.value) {
      changeSelectedComplex(null);
      return;
    }
    const selectedComplexObj = complexes.find(
      (complex) => complex.id === selectedComplexValueFromSelect.value,
    );
    changeSelectedComplex(selectedComplexObj);
    searchReccomendedTamplate(user.id, selectedComplexObj.period);
  };
  const transformedDataComplexes = complexes.map((complex) => {
    return {
      key: complex.id,
      value: complex.id,
      text: complex.name,
    };
  });

  return (
    <React.Fragment>
      <H1>Выберите комплекс курс</H1>
      <WrapComplexElements>
        <Select
          value={selectedComplex ? selectedComplex.id : null}
          options={transformedDataComplexes}
          onChange={(e, data) => onChangeComplex(data)}
          clearable
          disabled={loader}
          className="complex-select"
        />

        <ComplexControlButtonsBlock>
          <Button color="green" onClick={toggleCreateComplexModal}>
            Создать новый
          </Button>
          {selectedComplex && (
            <React.Fragment>
              <ChangeStatusPauseButton
                complex={selectedComplex}
                setIsDayOnPauseTomorrow={setIsDayOnPauseTomorrow}
                setIsPauseTakeOffTomorrow={setIsPauseTakeOffTomorrow}
                changeComplexPauseStatus={onHandlePause}
              />
              <Button color="blue" onClick={onHandleDateChange}>
                Изменить дату старта
              </Button>
            </React.Fragment>
          )}
        </ComplexControlButtonsBlock>
        <PauseInfoText>
          {(isPauseTakeOffTomorrow &&
            selectedComplex &&
            selectedComplex.finished_at &&
            `* Курс будет снят с паузы ${selectedComplex.finished_at}`) ||
            (isDayOnPauseTomorrow &&
              selectedComplex &&
              selectedComplex.paused_at &&
              `* Курс будет на паузе ${selectedComplex.paused_at}`) ||
            (selectedComplex &&
              selectedComplex.days_lef &&
              `* Количество дней на паузе: ${selectedComplex.days_left}`)}
        </PauseInfoText>
      </WrapComplexElements>
      <ChangeComplexStartDateModal
        isShow={isChangeComplexStartDate}
        onClose={setIsChangeComplexStartDate}
        changeComplexStartDate={onChangeComplexStartDate}
      />
      <CreateComplexModal
        isShow={isShowCreateComplexModal}
        onClose={toggleCreateComplexModal}
        userId={user.id}
        getComplexes={getComplexes}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.reducers;
  const { loader } = state.loader;
  const { isShowRecommendedTemplate } = state.folders;
  const {
    selectedComplex,
    complexes,
    isLoadingComplexes,
    isShowCreateComplexModal,
  } = state.complex;
  return {
    selectedComplex,
    complexes,
    isLoadingComplexes,
    loader,
    user,
    isShowCreateComplexModal,
    isShowRecommendedTemplate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getComplexes: (userId) => dispatch(getComplexes(userId)),
    changeSelectedComplex: (selectedComplexObj) =>
      dispatch(changeSelectedComplex(selectedComplexObj)),
    toggleCreateComplexModal: () => dispatch(toggleCreateComplexModal()),
    getFolders: (pageNumber, name, tags, userId, selectedComplexPeriod) => {
      dispatch(getFolders(pageNumber, name, tags, userId, selectedComplexPeriod));
    },
    setDayTabSelect: (number) => dispatch(setDayTabSelect(number)),
    setUserCurrentDay: (currentMenuDay) => dispatch(setUserCurrentDay(currentMenuDay)),
    changeComplexStartDate: (complexId, newDate, userId) =>
      dispatch(changeComplexStartDate(complexId, newDate, userId)),
    changeComplexPauseStatus: (complexId, newStatus, userId) =>
      dispatch(changeComplexPauseStatus(complexId, newStatus, userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Complex);

const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 10px;
`;

const ComplexControlButtonsBlock = styled.div`
  display: flex;
  margin-top: 10px;
  flex-wrap: nowrap;
`;
const WrapComplexElements = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
`;

const PauseInfoText = styled.p`
  text-align: center;
  font-size: 14px;
  margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/Complex/index.js